// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"197":"4806a0d1","456":"fb43a84a"}[chunkId] + ".css";
};